import {jsonMember} from "typedjson";

export class DxUserPrivilege {

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false})
  id: number;

  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false})
  name: string;

  constructor(fields?: Partial<DxUserPrivilege>) {
    if (fields)
      Object.assign(this, fields);
  }
}
